import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective } from "vue";
const _hoisted_1 = { class: "dropdown filter-button" };
const _hoisted_2 = {
    key: 0,
    class: "badge bg-primary ms-2"
};
const _hoisted_3 = ["data-is-open"];
const _hoisted_4 = { style: { "display": "flex", "flex-direction": "column", "width": "100%", "height": "100%" } };
const _hoisted_5 = {
    key: 0,
    class: "bg-light p-2 border-bottom",
    style: { "flex": "0 0 40px", "display": "flex", "align-items": "center", "justify-content": "center" }
};
const _hoisted_6 = { class: "input-group" };
const _hoisted_7 = { class: "input-group-append" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "currentColor",
    class: "bi bi-x",
    viewBox: "0 0 16 16"
}, [
    /*#__PURE__*/ _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" })
], -1);
const _hoisted_9 = [
    _hoisted_8
];
const _hoisted_10 = {
    class: "flex-grow-1",
    style: { "flex": "1 1 auto", "overflow-y": "auto" }
};
const _hoisted_11 = { class: "list-unstyled" };
const _hoisted_12 = ["onClick"];
const _hoisted_13 = { class: "flex-grow-1" };
const _hoisted_14 = { class: "d-flex flex-row" };
const _hoisted_15 = ["innerHTML"];
const _hoisted_16 = {
    class: "text-center",
    style: { "min-width": "40px", "width": "40px", "min-height": "24px" }
};
const _hoisted_17 = {
    key: 0,
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "currentColor",
    class: "d-inline-block mb-1",
    viewBox: "0 0 16 16"
};
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("path", { d: "M13.485 1.431a1.473 1.473 0 0 1 2.104 2.062l-7.84 9.801a1.473 1.473 0 0 1-2.12.04L.431 8.138a1.473 1.473 0 0 1 2.084-2.083l4.111 4.112 6.82-8.69a.486.486 0 0 1 .04-.045z" }, null, -1);
const _hoisted_19 = [
    _hoisted_18
];
const _hoisted_20 = {
    class: "p-2 bg-light border-top",
    style: { "flex": "0 0 40px", "display": "flex", "align-items": "center", "justify-content": "center" }
};
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "currentColor",
    class: "bi bi-x",
    viewBox: "0 0 16 16"
}, [
    /*#__PURE__*/ _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" })
], -1);
const _hoisted_22 = [
    _hoisted_21
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_click_outside = _resolveDirective("click-outside");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
            class: "btn btn-light border dropdown-toggle",
            type: "button",
            id: "dropdownMenuButton1",
            onClick: _cache[0] || (_cache[0] =
                //@ts-ignore
                (...args) => (_ctx.toogleButton && _ctx.toogleButton(...args)))
        }, [
            _createTextVNode(_toDisplayString(_ctx.filter.label) + " ", 1),
            (_ctx.selected.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.selected.length), 1))
                : _createCommentVNode("", true)
        ]),
        (_ctx.isOpen)
            ? _withDirectives((_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["dropdown-menu p-0 mt-1", { show: _ctx.isOpen }]),
                style: { "width": "300px", "height": "400px", "max-height": "400px" },
                "aria-labelledby": "dropdownMenuButton1",
                "data-is-open": _ctx.isOpen
            }, [
                _createElementVNode("div", _hoisted_4, [
                    (_ctx.filter?.allowFilter)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-control",
                                    style: { "z-index": "900" },
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.searchText) = $event)),
                                    ref: "txtSearch"
                                }, null, 512), [
                                    [_vModelText, _ctx.searchText]
                                ]),
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("button", {
                                        class: "input-group-text",
                                        style: { "height": "100%" },
                                        onClick: _cache[2] || (_cache[2] =
                                            //@ts-ignore
                                            (...args) => (_ctx.searchTextClear && _ctx.searchTextClear(...args)))
                                    }, _hoisted_9)
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("ul", _hoisted_11, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultValues, (value) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    onClick: ($event) => (_ctx.toogleSelection(value)),
                                    class: "d-flex border-bottom",
                                    style: { "cursor": "pointer" }
                                }, [
                                    _createElementVNode("div", _hoisted_13, [
                                        _createElementVNode("div", _hoisted_14, [
                                            (value.hexColor)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: "me-2",
                                                    style: _normalizeStyle('background-color: ' + value.hexColor + '; height: 100%; height: 20px; width: 20px; border-radius:2px;' + (value.hexColor === '#FFFFFF' ? 'border:#000 1px solid' : ''))
                                                }, null, 4))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("span", {
                                                innerHTML: _ctx.highlight(value.label)
                                            }, null, 8, _hoisted_15)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_16, [
                                        (_ctx.isSelected(value))
                                            ? (_openBlock(), _createElementBlock("svg", _hoisted_17, _hoisted_19))
                                            : _createCommentVNode("", true)
                                    ])
                                ], 8, _hoisted_12));
                            }), 256))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("button", {
                            class: "btn btn-warning me-2",
                            onClick: _cache[3] || (_cache[3] =
                                //@ts-ignore
                                (...args) => (_ctx.resetFilter && _ctx.resetFilter(...args))),
                            style: { "padding-bottom": "0.4rem" }
                        }, _hoisted_22),
                        _createElementVNode("button", {
                            class: "btn btn-success w-100",
                            onClick: _cache[4] || (_cache[4] =
                                //@ts-ignore
                                (...args) => (_ctx.applyButton && _ctx.applyButton(...args)))
                        }, "Übernehmen")
                    ])
                ])
            ], 10, _hoisted_3)), [
                [_directive_click_outside, _ctx.applyButton]
            ])
            : _createCommentVNode("", true)
    ]));
}
